<template>
    <div>
  
      <!-- <button class="p-button p-component p-button-help exportBtn" type="button" @click.prevent="exportCSV()">
        <span class="pi pi-upload p-button-icon p-button-icon-left"></span><span class="p-button-label">Export</span>
        <span class="p-ink"></span>
      </button> -->
  
        <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
      <DataTable ref="po"
                 :value="monthlyTargetLists"
                 :rowsPerPageOptions="[100,500,1000]" :paginator="true" :rows="100"
                 :filters="filters"
                 class="p-datatable-responsive p-datatable-gridlines">

        <Column header="S.n">
          <template #body="slotProps">
            {{ slotProps.index + 1 }}
          </template>
        </Column>

        <Column
          header="Month" :sortable="true"
          field="month_name"
          filterMatchMode="contains"
        >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['month_name']"/>
          </template>
        </Column>

    
        <Column :sortable="true"
                header="Target Amount"
                field="target_amount"
                filterMatchMode="contains"
        >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['target_amount']"/>
          </template>
        </Column>

        <Column :sortable="true"
                header="Sales Amount"
                field="achieve_amount"
                filterMatchMode="contains"
        >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['achieve_amount']"/>
          </template>
        </Column>

        <Column :sortable="true"
                header="Remaning Amount"
                field="remaining_amount"
                filterMatchMode="contains"
        >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['remaining_amount']"/>
          </template>
        </Column>


        <Column header="Action">
          <template #body="{data}">
            <Button icon="pi pi-pencil" class="p-button-success p-button-sm" @click="editTarget(data)" />
            <Button icon="pi pi-trash" class="p-button-danger p-button-sm" @click="confirmDelete(data.id)" />
          </template>
        </Column>
      </DataTable>
          </div>
         </div>
         <Dialog :visible.sync="DeleteDialog" :style="{ width: '700px !important' }" :modal="false" :closable="true" @hide="closeDialog">
          <template #header>Confirm Delete</template>
          <div class="p-field">
            <label>Delete Reason</label>
            <Textarea v-model="deleteReason" :rows="4" :autoResize="true" style="width: 100%; max-height: 200px; font-size: 16px;" />
          </div>
          <template #footer>
            <Button label="Delete" class="p-button-danger p-button-sm" @click="deleteTarget" />
            <Button label="Cancel" class="p-button-success p-button-sm" @click="closeDialog" />
          </template>
        </Dialog>
    </div>
  </template>
  <script>
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import Dialog from 'primevue/dialog'
  import globalKey from '../../../store/globalKey'
  import axios from 'axios'
  import Textarea from 'primevue/textarea/Textarea'
  import Button from 'primevue/button'
  import InputText from 'primevue/inputtext/InputText'
  
  export default {
    name: 'MonthlySaleTargetList',
    data() {
      return {
        dialogShow: false,
        accountId: '',
        columnList: '',
        filters: {},
        deleteReason: '',
        selectedId: null,
        DeleteDialog: false
      }
    },
    components: {
      DataTable,
      Column,
      Dialog,
      Textarea,
      Button,
      InputText
    },
    computed: {
      monthlyTargetLists() {
        return this.$store.state.sales.monthlyTargetLists
      }
    },
    mounted() {
      this.monthlyTargetList()
      this.columnNames()
    },
    methods: {
      async monthlyTargetList() {
        try {
          await this.$store.dispatch('loadMonthlyTargetList')
        } catch (e) {
        }
      },
      confirmDelete(id) {
        this.selectedId = id
        this.DeleteDialog = true
      },
      editMonthlyTarget(data) {
      // Emit the target data for editing
        this.$emit('edit-monthly-target', data)
      },

      async deleteTarget() {
        if (this.deleteReason.trim() === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason required', life: 3000})
          return
        }
        try {
          this.loading = true
          const response = await this.$store.dispatch('deleteMonthlyTarget', {
            id: this.selectedId,
            deleteReason: this.deleteReason
          })
          this.loading = false
          if (response.data.status === 'SUCCESS') {
            this.$toast.add({severity: 'success', summary: '', detail: 'Target deleted successfully', life: 3000})
            this.$emit('refresh-list')
            this.DeleteDialog = false
            this.deleteReason = ''
          } else {
            throw new Error('Delete failed')
          }
        } catch (error) {
          this.loading = false
          this.$toast.add({severity: 'error', summary: '', detail: 'Delete failed: ' + (error.message || 'Unknown error'), life: 5000})
        }
      },
      editTarget(target) {
        this.$emit('edit-target', target)
      },
      exportCSV() {
        let data = {
          columnList: this.columnList
        }
        axios({
          url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Account List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
          method: 'get',
          headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
          const link = document.createElement('a')
          const contentDisposition = response.headers['content-disposition']
          let fileName = 'accountList.xlsx'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1]
            }
          }
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
      },
      columnNames() {
        const columns = []
        for (let i = 0; i < this.$refs.po.columns.length; i++) {
          if (this.$refs.po.columns[i].header !== 'Action' &&
              this.$refs.po.columns[i].header !== 'S.n') {
            columns.push({
              header: this.$refs.po.columns[i].header,
              field: this.$refs.po.columns[i].field || ''
            })
          }
        }
        this.columnList = columns.map(col => col.header).join(',')
      },
      checkAccountType(data) {
        if (data.accountTypeName === 'Bank A/c' || data.accountTypeName === 'Customer A/c' || data.accountTypeName === 'Supplier A/c') {
          return true
        }
      },
      cancel(data) {
        this.dialogShow = false
      },
      openDialog(id) {
        this.dialogShow = true
        this.accountId = id
      },
      closeDialog() {
        this.dialogShow = false
        this.DeleteDialog = false
        this.deleteReason = ''
      }
    }
  }
  </script>
  
  <style>

  </style>



// WEBPACK FOOTER //
// monthlySaleTargetList.vue?18ddca0b